// @flow

import styled, { css } from "styled-components";
import { animated } from "@react-spring/web";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";
import { elevations } from "@fdr/static-ui/Elevations";

export type ToastType = "info" | "success" | "warning" | "error" | "pending";

const toastBgColor = (type: ToastType) => {
  switch (type) {
    case "success":
      return {
        backgroundColor: buildColor("green", "D1")
      };
    case "info":
      return {
        backgroundColor: buildColor("blue", "D1")
      };
    case "warning":
      return {
        backgroundColor: buildColor("orange", "D2")
      };
    case "error":
      return {
        backgroundColor: buildColor("red", "D1")
      };
    case "pending":
      return {
        backgroundColor: buildColor("purple")
      };
    default:
      return {
        backgroundColor: buildColor("green", "D1")
      };
  }
};

export const Wrapper = styled(animated.div)`
  position: absolute;
  display: flex;
  visibility: ${({ visibility }) => visibility};
  ${({ renderBottom }) =>
    renderBottom &&
    css`
      top: 100%;
    `}
  justify-content: center;
  color: ${buildColor("white")};
  width: 100%;
  z-index: 1100;
  pointer-events: none;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ isSmallToast }) => (isSmallToast ? "12px 16px" : "12px 24px")};
  border-radius: 100px;
  box-shadow: ${elevations.high};
  max-width: 312px;
  ${({ type }) => toastBgColor(type)};
  width: ${({ isSmallToast }) =>
    isSmallToast ? "fit-content" : "calc(100% - 40px)"};
  & svg {
    min-width: 17px;
  }
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: ${({ isSmallToast }) => (isSmallToast ? "0 2px" : "0 12px")};
`;

export const Title = styled.span`
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 700;
  line-height: 125%;
`;

export const SubTitle = styled.span`
  font-family: ${fontNormal};
  font-size: 12px;
  line-height: 125%;
`;

export const Action = styled.a`
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 700;
  line-height: 125%;
  color: ${buildColor("white")};
  text-decoration: none;
`;
